module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "height": "100%",
      "padding": "0"
    },
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "fill-height": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('AdminSideBarMenu'), _vm._v(" "), _c('v-flex', {
    staticClass: "dashboard-view"
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Access")])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "bordered-card",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n            Manage Access\n          ")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": "",
      "subheader": ""
    }
  }, [_c('v-list-tile', {
    staticClass: "title-toolbar"
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-select', {
    staticClass: "input-group--focused",
    attrs: {
      "items": _vm.roles,
      "label": "Select",
      "single-line": "",
      "hint": "Select a Role",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.currentRole),
      callback: function($$v) {
        _vm.currentRole = $$v
      },
      expression: "currentRole"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "max-width": "790px"
    },
    model: {
      value: (_vm.open_modal),
      callback: function($$v) {
        _vm.open_modal = $$v
      },
      expression: "open_modal"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "dark": "",
      "color": "primary"
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" Add role\n                ")], 1), _vm._v(" "), _c('NewRole', {
    attrs: {
      "activeDialog": _vm.activeDialog,
      "length": _vm.length
    }
  })], 1), _vm._v(" "), (_vm.currentRole !== 0) ? _c('v-dialog', {
    attrs: {
      "max-width": "790px",
      "fullscreen": _vm.screenWidth < 768,
      "lazy": "",
      "absolute": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "dark": "",
      "color": "red"
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("delete")]), _vm._v(" Delete role\n                ")], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "center headline"
  }, [_vm._v("Confirm delete")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete this role \" " + _vm._s(_vm.selectedPriviledge['title']) + " \"?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteRole()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("No")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.selectedPriviledge) ? _c('v-card', [(_vm.selectedPriviledge) ? _c('v-list', {
    attrs: {
      "three-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Events")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateData()
      }
    },
    model: {
      value: (_vm.selectedPriviledge.events.create_event),
      callback: function($$v) {
        _vm.$set(_vm.selectedPriviledge.events, "create_event", $$v)
      },
      expression: "selectedPriviledge.events.create_event"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Create Events")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allow users to be able to create events")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Activity Stream")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateData()
      }
    },
    model: {
      value: (_vm.selectedPriviledge.activity_stream.post_to_activity),
      callback: function($$v) {
        _vm.$set(_vm.selectedPriviledge.activity_stream, "post_to_activity", $$v)
      },
      expression: "selectedPriviledge.activity_stream.post_to_activity"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Post to Activity Stream")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allow users to be able to create post in activity stream")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Economic Impact")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.giveAllAccessToEconomicImpact()
      }
    },
    model: {
      value: (_vm.selectedPriviledge.economic_impact.all_access),
      callback: function($$v) {
        _vm.$set(_vm.selectedPriviledge.economic_impact, "all_access", $$v)
      },
      expression: "selectedPriviledge.economic_impact.all_access"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("All Access")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Give full access to the economic impact module")])], 1)], 1), _vm._v(" "), _vm._l((_vm.analysisList), function(analysis, index) {
    return _c('v-list-tile', {
      key: index
    }, [_c('v-list-tile-action', [_c('v-checkbox', {
      attrs: {
        "readonly": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.unCheckEconomicImpactAllAccess()
        }
      },
      model: {
        value: (_vm.selectedPriviledge.economic_impact[analysis.id]),
        callback: function($$v) {
          _vm.$set(_vm.selectedPriviledge.economic_impact, analysis.id, $$v)
        },
        expression: "selectedPriviledge.economic_impact[analysis.id]"
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(analysis.text))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Give access to the "), _c('span', {
      staticStyle: {
        "text-transform": "lowercase"
      }
    }, [_vm._v(_vm._s(analysis.text))])])], 1)], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Chat")]), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateData()
      }
    },
    model: {
      value: (_vm.selectedPriviledge.chat.group_chat),
      callback: function($$v) {
        _vm.$set(_vm.selectedPriviledge.chat, "group_chat", $$v)
      },
      expression: "selectedPriviledge.chat.group_chat"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Group Chats")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allow users to be able to send messages in groups")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateData()
      }
    },
    model: {
      value: (_vm.selectedPriviledge.chat.private_chat),
      callback: function($$v) {
        _vm.$set(_vm.selectedPriviledge.chat, "private_chat", $$v)
      },
      expression: "selectedPriviledge.chat.private_chat"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Private Chats")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allow users to be able to send private messages across users")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateData()
      }
    },
    model: {
      value: (_vm.selectedPriviledge.chat.video_chat),
      callback: function($$v) {
        _vm.$set(_vm.selectedPriviledge.chat, "video_chat", $$v)
      },
      expression: "selectedPriviledge.chat.video_chat"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Video Chats")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Enables users access to video chats")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateData()
      }
    },
    model: {
      value: (_vm.selectedPriviledge.chat.voice_chat),
      callback: function($$v) {
        _vm.$set(_vm.selectedPriviledge.chat, "voice_chat", $$v)
      },
      expression: "selectedPriviledge.chat.voice_chat"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Voice Chats")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Enables users access to voice chats")])], 1)], 1)], 2) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Email Updates")]), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateData()
      }
    },
    model: {
      value: (_vm.selectedPriviledge.email_updates.access),
      callback: function($$v) {
        _vm.$set(_vm.selectedPriviledge.email_updates, "access", $$v)
      },
      expression: "selectedPriviledge.email_updates.access"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Enable Access")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allows users to receive email updates")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action'), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Set limit for Email Update")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Limit the number of email updates")])], 1), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.selectedPriviledge.email_updates.limit),
      callback: function($$v) {
        _vm.$set(_vm.selectedPriviledge.email_updates, "limit", $$v)
      },
      expression: "selectedPriviledge.email_updates.limit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "5",
      "value": 5
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateData()
      }
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "10",
      "value": 10
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateData()
      }
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.selectedPriviledge) ? _c('div', {
    staticClass: "pa-4"
  }, [_c('v-alert', {
    attrs: {
      "color": "secondary",
      "value": true
    }
  }, [_vm._v("\n            No Role has been selected, Please select role to display above\n          ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('PageFooter')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f809752","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/PriviledgesView.vue
// module id = 1667
// module chunks = 10